export const not = <T extends (...args: any[]) => boolean>(fn: T): T =>
    ((...args: Parameters<T>) => !fn(...args)) as T;

export const and = <T extends (...args: any[]) => boolean>(...fns: T[]): T =>
    ((...args: Parameters<T>) => fns.every(fn => fn(...args))) as T;

export const or = <T extends (...args: any[]) => boolean>(...fns: T[]): T =>
    ((...args: Parameters<T>) => fns.some(fn => fn(...args))) as T;
